const Area = () =>
  import(
    /* webpackChunkName: "cms-area" */ '@/pages/cms/content/area/index.vue'
  )

const CreateArea = () =>
  import(
    /* webpackChunkName: "cms-area" */ '@/pages/cms/content/area/create.vue'
  )

const EditArea = () =>
  import(/* webpackChunkName: "cms-area" */ '@/pages/cms/content/area/edit.vue')

export default {
  path: 'area',
  meta: {
    label: 'area',
    auth: 'area'
  },
  component: {
    name: 'Area',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CmsAreaReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Area
    },
    {
      name: 'CmsCreateArea',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateArea
    },
    {
      name: 'CmsEditArea',
      path: 'area/edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditArea,
      props: true
    }
  ]
}
